import { Dialog, Typography, styled, Stack } from '@mui/material'
import { Loading } from '$common/loading/chat-loading'

const Wrapper = styled(Dialog)`
  .MuiDialog-paper {
    width: 225px;
    height: 131px;
    min-width: 225px;
    min-height: 131px;
    padding: 35px 0;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Root = styled(Stack)`
  width: 100%;
  height: 100%;

  justify-content: space-between;
  align-items: center;
  overflow: hidden;
`

interface Props {
  text: string
  isOpen: boolean
}

export function LoadingModal({ text, isOpen }: Props) {
  return (
    <Wrapper open={isOpen}>
      <Root>
        <Loading color="#97B6D8" /> {/* TODO: Add me to theme */}
        <Typography color="semiBlack">{text}</Typography>
      </Root>
    </Wrapper>
  )
}
